import React from "react";
import { defaultIconProps, IconProps, sizeMap } from "./types";

export const PokemonIcon = ({
  size = defaultIconProps.size,
  color = defaultIconProps.color,
  className = "",
  fontSize,
}: IconProps) => {
  const pixelSize = fontSize ?? sizeMap[size as keyof typeof sizeMap];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      className={`inline-block ${className}`}
      width={pixelSize}
      height={pixelSize}
    >
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 1.5c4.69 0 8.5 3.81 8.5 8.5h-4.76a3.75 3.75 0 0 0-7.48 0H3.5c0-4.69 3.81-8.5 8.5-8.5zM12 14.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zm-8.5-1.75c0 4.69 3.81 8.5 8.5 8.5s8.5-3.81 8.5-8.5h-4.76a3.75 3.75 0 0 1-7.48 0H3.5z" />
    </svg>
  );
};
